import { createContext } from 'react'

import { createAuctionListStore } from '../store/createStore'

export const AuctionListStoreContext = createContext<
  ReturnType<typeof createAuctionListStore> | undefined
>(undefined)
